export const navItems = {
  header: [
    {
      label: "Docs",
      href: "/docs",
    },
    {
      label: "Components",
      href: "/docs/components/button",
    },
    {
      label: "Blocks",
      href: "/docs/blocks/footer",
    },
  ],
  navMain: [
    {
      title: "Components",
      url: "/components/button",
      items: [
        { title: "Button", url: "/docs/components/button", new: false },
        { title: "Input", url: "/docs/components/input", new: false },
        {
          title: "GitHub Button",
          url: "/docs/components/github-button",
          new: true,
        },
        { title: "Carousel", url: "/docs/components/carousel", new: true },
        { title: "Modal", url: "/docs/components/modal", new: true },
        { title: "Alert", url: "/docs/components/alert", new: true },
        { title: "Accordion", url: "/docs/components/accordion", new: true },
        { title: "Card", url: "/docs/components/card", new: false },
        {
          title: "Destination Card",
          url: "/docs/components/destination-card",
          new: true,
        },
        { title: "Avatar", url: "/docs/components/avatar", new: true },
        { title: "Badge", url: "/docs/components/badge", new: false },
        { title: "Loader", url: "/docs/components/loader", new: true },
      ],
    },
    {
      title: "Blocks",
      url: "blocks/footer",
      items: [
        { title: "Footer", url: "/docs/blocks/footer", new: true },
        { title: "Hero", url: "/docs/blocks/hero", new: true },
      ],
    },
  ],
};
